
import './index.less';
import Picker from 'vux/src/components/picker/index.vue'

import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import bus from '@/javascript/bus'

let years=[]
for (var i = 1; i <= 15; i++) {
years.push({
name: i,
value: i + ''
})
}

export default {
components:{
Cpts020,
Picker
},
data(){
return{
minHeight:0,
years: [years],
year1:[],
closeWin:false,
needDay:3,
params: JSON.parse(sessionStorage.getItem('historyData')),
historyData: '',
showbtn: false,
oldDays: ''
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight

document.title = this.PAGE_TITLE + '出行天数'
if(JSON.stringify(this.params) !== '{}' && this.params.travelId){
this.needDay = this.params.planDays
this.oldDays = this.params.planDays
this.showbtn = true
}else if(this.params.planDays){
this.needDay = this.params.planDays
this.oldDays = this.params.planDays
}
},
methods: {
closeWindow:function(){
this.closeWin=false
this.needDay=this.year1[0]
},
showWindows:function(){
this.closeWin=true
},
nextStep(){
this.params['planDays'] = this.needDay
if(this.oldDays !== this.needDay){
this.params['changeDays'] = true
}
sessionStorage.setItem('historyData', JSON.stringify(this.params))

this.$router.push({path: '/choose-spot'})
},
creatTrip: function(){
this.params['planDays'] = this.needDay
sessionStorage.setItem('historyData', JSON.stringify(this.params))

this.$router.push({path: '/data-compute'})
if(this.params.createId && this.params.createId !== bus.userInfo.user.id){
this.$http.get("/wtcp-recommend/public/travelPlan/app/reference?id=" + this.params.travelId[0].nowId + "&userId=" + bus.userInfo.user.id + '&deptCode=' + this.DEPT_CODE.DEPTCODE).then((response) => {

})
}
}
},
}
